export default __webpack_public_path__ + "static/media/ante-trust-a.d4213b8c.svg";